module.exports = __webpack_public_path__ + "media/pt_pt_s1_Beatriz.ae0df640.oga";